import { SlingoEvent } from "@lib/titan2-slingo/dist/game/controller/event/SlingoEvent";
import { TweenConstants } from "@lib/titan2-slingo/dist/game/view/abstract/constant/TweenConstants";
import { TitanSpine } from "@lib/titan2/dist/game/control/TitanSpine";
import { gsap } from "gsap";
import { SpineUtil } from "@lib/titan2/dist/util/view/SpineUtil";
import { addToTitanSpineSlot } from "../../../utils/SpineUtils";
import { AbstractGameView } from "@lib/titan2-slingo/dist/game/view/abstract/display/AbstractGameView";
import { TitanText } from "@lib/titan2/dist/game/control/TitanText";
import { CommonGameEvent } from "@lib/titan2/dist/game/controller/event/CommonGameEvent";
import { ViewUtils } from "@lib/titan2/dist/util/view/ViewUtils";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
import { MouseBlocker } from "@lib/titan2/dist/game/control/MouseBlocker";
export class GameFullHouse extends AbstractGameView {
    constructor(factory, landscapeProperties, portraitProperties) {
        super(factory, landscapeProperties, portraitProperties);
    }
    addEventListeners() {
        super.addEventListeners();
        super.addEventListeners();
        this.registerGame(CommonGameEvent.PURCHASE_ENTRY, this.reset);
        this.registerGame(SlingoEvent.FULL_HOUSE_ANIMATION_PHASE_TWO, this.handlePlayFullHouse);
    }
    postCreate() {
        super.postCreate();
        this.reset();
        Logger.addObjectRef(this, "GameScatterWin");
    }
    reset() {
        SpineUtil.reset(this.animation);
    }
    create() {
        super.create();
        this.createMouseBlocker();
        this.titleContainer = ViewUtils.createContainer(this);
        this.title = TitanText.createField(this.titleContainer, this.landscapeProperties.titleProperties, this.portraitProperties?.titleProperties);
        this.animation = TitanSpine.createSpine(this, this.landscapeProperties.animation, this.portraitProperties?.animation);
        this.titleContainer.visible = false;
    }
    createMouseBlocker() {
        if (this.uiProperties.mouseBlockerProperties) {
            this.mouseBlocker = new MouseBlocker(this.landscapeProperties.mouseBlockerProperties, this.portraitProperties?.mouseBlockerProperties);
        }
    }
    showOverlay() {
        if (this.mouseBlocker) {
            this.mouseBlocker.alpha = 0;
            this.addChildAt(this.mouseBlocker, 0);
            gsap.to(this.mouseBlocker, { duration: TweenConstants.DEFAULT_OVERLAY_FADE_DURATION, alpha: 1 });
        }
    }
    hideOverlay() {
        this.mouseBlocker && gsap.to(this.mouseBlocker, {
            duration: TweenConstants.DEFAULT_OVERLAY_FADE_DURATION,
            alpha: 0,
            onComplete: () => {
                this.removeChild(this.mouseBlocker);
            }
        });
    }
    async handlePlayFullHouse() {
        const localise = this.shouldLocalise();
        this.titleContainer.visible = localise;
        const introAnim = localise ? "FullHouseTranslated-intro" : "FULLHOUSE intro";
        const idleAnim = localise ? "FullHouseTranslated-loop" : "FULLHOUSE loop";
        const outroAnim = localise ? "FullHouseTranslated-outro" : "FULLHOUSE outro";
        if (localise) {
            addToTitanSpineSlot(this.animation, this.titleContainer, "dynamic-text-base");
        }
        this.dispatchGame(SlingoEvent.SCATTER_WIN_APPEAR);
        this.showOverlay();
        SpineUtil.play(this.animation, introAnim, () => {
            SpineUtil.playLoop(this.animation, idleAnim);
        });
        this.animation.getSpine().update(0.01);
        await gsap.to(null, { duration: 3 });
        SpineUtil.play(this.animation, outroAnim, () => {
            this.hideOverlay();
            this.titleContainer.visible = false;
            this.dispatchGame(SlingoEvent.FULL_HOUSE_ANIMATION_COMPLETE);
        });
    }
    shouldLocalise() {
        return !this.langManager.getLocale().getId().includes("en");
    }
}
//# sourceMappingURL=GameFullHouse.js.map